import { useAuthStore } from '@/store/auth-store'
import type { AuthUser } from '@/features/auth/types/auth.types'

/**
 * Checagem de permissão só para UX (esconder/desabilitar UI) — nunca é a fonte
 * de verdade de autorização, que continua sendo sempre aplicada pelo backend.
 * `super_admin` sempre passa, independente do array `permissions`.
 */
export function hasPermission(user: AuthUser | null, code: string): boolean {
  if (!user) return false
  if (user.role === 'super_admin') return true
  return user.permissions.includes(code)
}

export function usePermission(code: string): boolean {
  const user = useAuthStore((state) => state.user)
  return hasPermission(user, code)
}
